import { render } from "./Prizepool.vue?vue&type=template&id=63b1d04e&scoped=true&bindings={\"active\":\"setup\",\"dollar\":\"setup\",\"goal\":\"setup\",\"donators\":\"setup\",\"sponsors\":\"setup\",\"total\":\"setup\",\"duelPrizes\":\"setup\",\"draftPrizes\":\"setup\",\"duelTotalPrize\":\"setup\",\"draftTotalPrize\":\"setup\",\"toStringAmount\":\"setup\",\"t\":\"setup\"}"
import script from "./Prizepool.vue?vue&type=script&lang=js"
export * from "./Prizepool.vue?vue&type=script&lang=js"

import "./Prizepool.vue?vue&type=style&index=0&id=63b1d04e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-63b1d04e"

export default script